import Vue from 'vue';
import { i18nPlugin } from '@sailor/i18n-vue';
import { RegionReader } from '@osgfe/web-region-store';
import resources from './assets/locales/resources';

const region = RegionReader.getCurRegion().code;

Vue.use(i18nPlugin, (i18nClient) => {
    i18nClient.init({
        resources,
        ns: 'b_fe_vss',
        backend: {
            openI18nKeyRaptor: true,
            i18nKeyRaptorConfig: {
                clientAppkey: window.__locals__.appKey,
                region,
                projectId: 43,
                namespaceId: 'qjpecyxapi',
            },
            useSailorCompass: true, // ✅ 使用罗盘获取 i18n host 域名
            idc: process_env_publishIdc, // ✅ 'HK' or 'EU'，根据机房动态获取
        },
    }, () => {
        window.i18nClient = i18nClient;
        window.getText = i18nClient.t;
    });
});
